/** Mount point of the Aithora router (src/server.ts: app.use('/api/aithora', ...)). */
export const AITHORA_PREFIX = '/api/aithora';
